import adminMenuItems from './adminMenuItems';
import settingsMenuItems from './settingsMenuItems';
import { reportsMenuItems, getReportsMenuItems } from './reportsMenuItems';

const filterMenuItemsByRole = (m, menuPermission) => {
    if (m.hasOwnProperty('required')) {
        for (const k in m.required) {
            if (menuPermission.hasOwnProperty(k) && menuPermission[k] === m.required[k]) {
                return m;
            }
        }
        return null;
    }
    if (m.hasOwnProperty('children') && m.children.length > 0) {
        const filteredChildren = iterateMenuItems(m.children, menuPermission);
        if (filteredChildren?.length > 0) {
            return { ...m, children: filteredChildren };
        } else {
            return null;
        }
    }
    return m;
};
const iterateMenuItems = (children, menuPermission) => {
    let i = 0;
    for (;;) {
        if (!children[i].hasOwnProperty('children')) {
            let bAdd = false;
            if (!children[i].hasOwnProperty('required')) {
                bAdd = true;
            } else {
                for (const k in children[i].required) {
                    if (menuPermission.hasOwnProperty(k) && menuPermission[k] === children[i].required[k]) {
                        bAdd = true;
                        break;
                    }
                }
            }
            if (!bAdd) {
                children.splice(i, 1);
            } else {
                i++;
            }
        } else {
            iterateMenuItems(children[i].children, menuPermission);
            i++;
        }
        if (i >= children.length) {
            break;
        }
    }
    return children;
};

const getMenuGroupPermissions = (admin_permissions, groupPermissions, isManagingOrg) => {
    let gPermission = {};
    for (const [k, v] of Object.entries(groupPermissions)) {
        for (const [vName, vValue] of Object.entries(v)) {
            if (gPermission.hasOwnProperty(vName) && !!gPermission[vName]) {
                continue;
            }
            gPermission[vName] = vValue;
        }
    }
    if (admin_permissions.root_admin) {
        if (isManagingOrg) {
            gPermission['server_admin'] = true;
        } else {
            gPermission['root_admin'] = true;
        }
    } else {
        gPermission = { ...gPermission, ...admin_permissions };
    }
    return gPermission;
};

export const getMenuItems = async (admin_permissions, group_permissions, isManagingOrg) => {
    let adminItems = {};
    const menuItems = [];
    const menuPermission = getMenuGroupPermissions(admin_permissions, group_permissions, isManagingOrg);
    let settingsItems = {};

    adminItems = filterMenuItemsByRole(JSON.parse(JSON.stringify(adminMenuItems)), menuPermission);
    settingsItems = filterMenuItemsByRole(JSON.parse(JSON.stringify(settingsMenuItems)), menuPermission);
    if (adminItems) {
        menuItems.push(adminItems);
    }
    if (settingsItems) {
        menuItems.push(settingsItems);
    }
    if (!admin_permissions.root_admin || (admin_permissions.root_admin && isManagingOrg)) {
        const items = await getReportsMenuItems();
        //await getReportsMenuItems();
        menuItems.push(items);
    }
    return { items: menuItems };
};
export default {
    getMenuItems
};
